module.exports = __webpack_public_path__ + "static/img/19034C_1_2_C_20220302_fit.0b6db79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19034C_1_2_C_20220302_fit.png
// module id = ald8
// module chunks = 0